import styled from "@emotion/styled";
import { CustomThemeType } from "../../../context/Providers";

export const PageWrapper = styled.div<{ theme?: CustomThemeType }>`
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.background};
  color: ${(p) => p.theme.foreground};
  font-family: "Inter", sans-serif;
  overflow-y: auto;
  overscroll-behavior-y: contain;
`;

export const Header = styled.header<{ theme?: CustomThemeType }>`
  padding: 3rem 6rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, ${(p) => p.theme.brand}, ${(p) => p.theme.background} 40%),
    ${(p) => p.theme.background}
  );
  @media (max-width: 1024px) {
    padding: 2.5rem 2.5rem 1rem;
  }
  @media (max-width: 768px) {
    padding: 2rem 1.5rem 1rem;
  }
`;

export const Brand = styled.span<{ theme?: CustomThemeType }>`
  font-size: 2.5rem;
  font-weight: 600;
  color: ${(p) =>
    `color-mix(in srgb, ${p.theme.foreground}, ${p.theme.brand} 30%)`};
`;

export const HeroHeadline = styled.h1<{ theme?: CustomThemeType }>`
  margin: 0;
  font-size: clamp(2.25rem, 4vw, 3.5rem);
  font-weight: 600;
  color: ${(p) => p.theme.foreground};
`;

export const UpdatedDate = styled.p<{ theme?: CustomThemeType }>`
  margin: 0;
  font-size: 1rem;
  color: color-mix(
    in srgb,
    ${(p) => p.theme.foreground},
    ${(p) => p.theme.background} 45%
  );
`;

export const Content = styled.main<{ theme?: CustomThemeType }>`
  flex: 1;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 3rem 4rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  line-height: 1.6;
  @media (max-width: 1024px) {
    padding: 2.5rem 2.5rem 3rem;
  }
  @media (max-width: 768px) {
    padding: 2rem 1.5rem 3rem;
  }
`;

export const Section = styled.section<{ theme?: CustomThemeType }>`
  background-color: color-mix(
    in srgb,
    ${(p) => p.theme.background},
    ${(p) => p.theme.foreground} 6%
  );
  border: 1px solid
    color-mix(
      in srgb,
      ${(p) => p.theme.foreground},
      ${(p) => p.theme.background} 80%
    );
  border-radius: 1rem;
  padding: 2rem 2.5rem;
  box-shadow: 0 18px 34px -24px
    color-mix(in srgb, ${(p) => p.theme.foreground}, transparent 85%);
  @media (max-width: 768px) {
    padding: 1.75rem 1.75rem;
  }
`;

export const SectionHeading = styled.h2<{ theme?: CustomThemeType }>`
  margin: 0 0 1.25rem 0;
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 600;
  color: ${(p) => p.theme.foreground};
`;

export const Paragraph = styled.p<{ theme?: CustomThemeType }>`
  margin: 0 0 1rem 0;
  color: color-mix(
    in srgb,
    ${(p) => p.theme.foreground},
    ${(p) => p.theme.background} 35%
  );
  font-size: 1.05rem;
`;

export const List = styled.ul<{ theme?: CustomThemeType }>`
  margin: 0 0 1rem 1.2rem;
  padding: 0;
  color: color-mix(
    in srgb,
    ${(p) => p.theme.foreground},
    ${(p) => p.theme.background} 35%
  );
  font-size: 1.05rem;
  display: grid;
  gap: 0.75rem;
`;

export const Strong = styled.span<{ theme?: CustomThemeType }>`
  color: ${(p) => p.theme.foreground};
  font-weight: 600;
`;

export const ContactBlock = styled.div<{ theme?: CustomThemeType }>`
  display: grid;
  gap: 0.5rem;
  color: color-mix(
    in srgb,
    ${(p) => p.theme.foreground},
    ${(p) => p.theme.background} 35%
  );
  font-size: 1.05rem;
`;
